module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/devices/device-detail/sensor-detail/sensor-detail.component.scss
// module id = ./src/app/entities/devices/device-detail/sensor-detail/sensor-detail.component.scss
// module chunks = main